import React from 'react';
import { PauseIcon, PlayIcon, Volume2Icon, VolumeXIcon } from 'lucide-react';
interface ReelControlsProps {
  playing: boolean;
  soundOn: boolean;
  onToggle: () => void;
  onToggleSound: () => void;
}
const button = 'flex h-11 w-11 items-center justify-center rounded-full bg-ink/70 text-cream backdrop-blur-md transition-[background-color,transform] duration-150 ease-out hover:bg-ink/85 active:scale-[0.96] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cream';

/** Floating play/pause + sound controls, tucked into the frame's bottom-right corner. */
export function ReelControls({
  playing,
  soundOn,
  onToggle,
  onToggleSound
}: ReelControlsProps) {
  return <div className="absolute bottom-3 right-3 z-10 flex items-center gap-2 md:bottom-5 md:right-5" data-id="element-293" data-mp="2jwyqks3v8x3g">
      <button type="button" onClick={onToggle} aria-label={playing ? 'Pause reel' : 'Play reel'} className={button} data-id="element-294" data-mp="13j8n9nkkmcuv">
        {playing ? <PauseIcon className="h-[18px] w-[18px]" fill="currentColor" data-id="element-295" data-mp="18h1rwc686yt1" /> : <PlayIcon className="ml-0.5 h-[18px] w-[18px]" fill="currentColor" data-id="element-296" data-mp="1h8sub8usxaty" />}
      </button>
      <button type="button" onClick={onToggleSound} aria-pressed={soundOn} aria-label={soundOn ? 'Mute sound' : 'Turn sound on'} className={button} data-id="element-297" data-mp="1c9zswesshaa5">
        {soundOn ? <Volume2Icon className="h-[18px] w-[18px]" data-id="element-298" data-mp="1m6b6r981286p" /> : <VolumeXIcon className="h-[18px] w-[18px]" data-id="element-299" data-mp="206vpk5dy0407" />}
      </button>
    </div>;
}